import { render, staticRenderFns } from "./StockRecovery.vue?vue&type=template&id=00c0a158"
import script from "./StockRecovery.vue?vue&type=script&lang=js"
export * from "./StockRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c0a158')) {
      api.createRecord('00c0a158', component.options)
    } else {
      api.reload('00c0a158', component.options)
    }
    module.hot.accept("./StockRecovery.vue?vue&type=template&id=00c0a158", function () {
      api.rerender('00c0a158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/StockRecovery.vue"
export default component.exports